// Session management utilities for floodlight tracking

// Generate a unique session ID that persists for the browser session
export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("floodlight_session_id");

  if (!sessionId) {
    // Generate a new session ID
    sessionId =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15) +
      Date.now().toString(36);
    sessionStorage.setItem("floodlight_session_id", sessionId);
  }

  return sessionId;
};
